import classNames from "classnames"
import React from "react"

import { useReferrals } from "@bounce/referrals"

import SafeLink from "@/components/Generic/SafeLink/SafeLink"
import { StoreItemListStructuredData } from "@/components/Generic/StructuredData/StoreItemListStructuredData"
import { useStoreSuggestions } from "@/components/LuggageStorage/Store/hooks/useStoreSuggestions"
import type { NearbyStorageSpot } from "@/libs/bounce/stores/types"
import type { PageType } from "@/types"

export type StoreListProps = {
  children: (store: NearbyStorageSpot) => React.ReactNode
  className?: string
  from: PageType
  path: string
  searchQuery: string
  stores: NearbyStorageSpot[]
}

export const StoreList = ({ children, className, from, path, searchQuery, stores }: StoreListProps) => {
  const { coupon: couponCode } = useReferrals.useCodes()
  const { handleClickStore, handleGetStoreUrl } = useStoreSuggestions({ couponCode, from, searchQuery })

  return (
    <>
      <ul className={classNames("mt-6 grid grid-cols-1 gap-6 px-6 md:gap-y-12 lg:px-0", className)}>
        {stores.map(store => (
          <li key={store.id} className="h-full">
            <SafeLink
              href={handleGetStoreUrl(store)}
              onClick={ev => handleClickStore(ev, store)}
              target="_self"
              className="block h-full">
              {children(store)}
            </SafeLink>
          </li>
        ))}
      </ul>
      <StoreItemListStructuredData path={path} stores={stores} />
    </>
  )
}
